<div fxLayout="row" class="background">
    <div fxFlex="80" fxFlexOffset="10%">

        <section id="header">
            <h1 class="h1Header">{{title}}</h1>
        </section>

        <section id="body">
            <form [formGroup]="addShopTypeForm" (ngSubmit)="saveChanges(addShopTypeForm.value)">
                <mat-card>
                    <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
                        <div fxFlex="50">
                            <mat-form-field appearance="outline">
                                <mat-label>Nombre</mat-label>
                                <input matInput formControlName="DsName" required>
                                <mat-error *ngIf="addShopTypeForm.controls['DsName'].hasError('required')">
                                    Este campo es obligatorio
                                </mat-error>
                                <mat-error *ngIf="addShopTypeForm.controls['DsName'].hasError('pattern')">
                                    Este campo sólo admite caracteres alfabéticos.
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div fxFlex="50">
                            <mat-form-field appearance="outline">
                                <mat-label>Estado</mat-label>
                                <mat-select formControlName="IsEnabled" required>
                                    <mat-option *ngFor="let option of options" [value]="option.value">
                                        {{option.viewValue}}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="addShopTypeForm.controls['IsEnabled'].hasError('required')">
                                    Este campo es obligatorio
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
                        <div fxFlex="50">
                            <mat-form-field appearance="outline">
                                <mat-label>Imagen</mat-label>
                                <ngx-mat-file-input formControlName="ItemImage" accept=".png, .jpg, .jpeg">
                                </ngx-mat-file-input>
                                <mat-error *ngIf="addShopTypeForm.controls['ItemImage'].hasError('required')">
                                    Este campo es obligatorio
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div fxFlex="50">
                            <mat-form-field appearance="outline">
                                <mat-label>Descripción</mat-label>
                                <input matInput formControlName="DsDescription" required>
                                <mat-error *ngIf="addShopTypeForm.controls['DsDescription'].hasError('required')">
                                    Este campo es obligatorio
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-card>
                <br>
                <div fxLayout="row" fxLayoutAlign="start center">
                    <button mat-flat-button type="submit" [disabled]="!addShopTypeForm.valid"
                        class="save-changes">GUARDAR CAMBIOS</button>
                    <button routerLink="/shop-type-management" mat-raised-button class="cancel-changes">
                        CANCELAR</button>
                </div>
            </form>
        </section>

    </div>
</div>
